import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { CustomPreloadingStrategy } from './custom-preloading.strategy';

const routes: Routes = [
  {
    path: '', 
    loadChildren: () => import('./home-module/home-module.module').then(m => m.HomeModuleModule),
    data: { preload: true },
  },
  {
    path: '', 
    loadChildren: () => import('./db-module/db-module.module').then(m => m.DbModuleModule),
    data: { preload: false },
  },
  {
    path: '', 
    loadChildren: () => import('./about-module/about-module.module').then(m => m.AboutModuleModule),
    data: { preload: false },
  },
  {
    path: '', 
    loadChildren: () => import('./privacy-module/privacy-module.module').then(m => m.PrivacyModuleModule),
    data: { preload: false },
  },
  {
    path: '',
    loadChildren: () => import('./login-module/login-module.module').then(m => m.LoginModuleModule),
    data: { preload: false },
  },
  {
    path: '', 
    loadChildren: () => import('./userdashboard-module/userdashboard-module.module').then(m => m.UserdashboardModuleModule),
    data: { preload: false },
  },

  {
    path: '', 
    loadChildren: () => import('./blog-module/blog-module.module').then(m => m.BlogModuleModule),
    data: { preload: false },
  },
  {
    path: '', 
    loadChildren: () =>import('./case-study-module/case-study-module.module').then(m => m.CaseStudyModuleModule),
    data: { preload: false },
  },
  {
    path: '', 
    loadChildren: () => import('./pressmedia-module/pressmedia-module.module').then(m => m.PressmediaModuleModule),
    data: { preload: false },
  },
  {
    path: '', 
    loadChildren: () => import('./result-module/result-module.module').then(m => m.ResultModuleModule),
    data: { preload: false },
  },
  {
    path: '', 
    loadChildren: () => import('./testimonial-module/testimonial-module.module').then(m => m.TestimonialModuleModule),
    data: { preload: false },
  },
  {
    path: '', 
    loadChildren: () =>import('./video-module/video-module.module').then(m => m.VideoModuleModule),
    data: { preload: false },
  },
  {
    path: '', 
    loadChildren: () => import('./service-module/service-module.module').then(m => m.ServiceModuleModule),
    data: { preload: false },
  },
  
  { path: '**', redirectTo: '404', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabled',
      preloadingStrategy: CustomPreloadingStrategy,  // Use custom strategy
      // preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
  providers: [CustomPreloadingStrategy]
})
export class AppRoutingModule { }
